export const PMAX_ERRORS_CODES = [
    "OE-FRA-0313", // Invalid name
    "OE-FRA-0315", // Segment C5 only
    "OE-FRA-0316", // Linky communicating meter required
    "OE-FRA-0317", // Sensitive meter not supported
    "OE-FRA-0318", // Category PART only
    "OE-FRA-0319", // Limited meters (LIMI vs ALIM) not supported
    "OE-FRA-0320", // Single-phase meter only
    "OE-FRA-0321", // Power history missing
    "OE-FRA-0324", // Analysis too soon after power decrease
    "OE-FRA-0325", // Analysis too soon after power increase
    "OE-FRA-0326", // Not enough data on fresh months
    "OE-FRA-0327", // Not enough data on winter months
    "OE-FRA-0328", // Too many historical values equal to zero
]

